import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['modalButton'];

  connect() {
    this.element.addEventListener('filter-applied', this.handleFilterApplied.bind(this));
  }

  disconnect() {
    this.element.removeEventListener('filter-applied', this.handleFilterApplied.bind(this));
  }

  handleFilterApplied(event) {
    if (!this.hasModalButtonTarget) return;

    const { anyFilterApplied } = event.detail;

    if (anyFilterApplied) {
      this.modalButtonTarget.setAttribute('data-active', 'true');
    } else {
      this.modalButtonTarget.removeAttribute('data-active');
    }
  }
}
